const ACCEPTED_TYPES = new Set(['image/jpeg', 'image/png', 'image/webp'])

export function isAcceptedProfileImage(file: File): boolean {
  return ACCEPTED_TYPES.has(file.type)
}

export async function fileToResizedDataUrl(file: File, maxEdge: number, quality = 0.84): Promise<string> {
  if (!isAcceptedProfileImage(file)) {
    throw new Error('Yalnızca JPG, PNG veya WebP yükleyebilirsiniz.')
  }
  if (file.size > 8 * 1024 * 1024) {
    throw new Error('Dosya en fazla 8 MB olabilir.')
  }

  const bitmap = await createImageBitmap(file)
  try {
    const longest = Math.max(bitmap.width, bitmap.height)
    const scale = longest > maxEdge ? maxEdge / longest : 1
    const width = Math.max(1, Math.round(bitmap.width * scale))
    const height = Math.max(1, Math.round(bitmap.height * scale))
    const canvas = document.createElement('canvas')
    canvas.width = width
    canvas.height = height
    const ctx = canvas.getContext('2d')
    if (!ctx) throw new Error('Görsel işlenemedi')
    ctx.drawImage(bitmap, 0, 0, width, height)
    return canvas.toDataURL('image/jpeg', quality)
  } finally {
    bitmap.close()
  }
}
